import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editOrganization(
    credentials: Boundaries["editOrganization"]["request"],
  ): void;
}

function useEditOrganization(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditOrganizationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditOrganizationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditOrganizationRequestFailure(planzone),
    ),
    editOrganization: core.editOrganization,
  };
}

export { useEditOrganization };
